import { render, staticRenderFns } from "./IotSetupUser.vue?vue&type=template&id=67066436"
import script from "./IotSetupUser.vue?vue&type=script&lang=js"
export * from "./IotSetupUser.vue?vue&type=script&lang=js"
import style0 from "./IotSetupUser.vue?vue&type=style&index=0&id=67066436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports